// DESPFY-380 - .scrolled flag only.
//
// The navigation row is permanently visible (matching www.shoplc.com), so there is no
// scroll-direction tracking here any more and no --shoplc-nav-offset to keep in sync. What is
// left is the .scrolled class, which four rules depend on: the yotpo z-index rule and the
// search-modal rule in assets/header.css, plus two rules in
// snippets/predictive-search-new.liquid.
//
// Note the theme's own header-component script (assets/header.js) cannot be used for this - it is
// never loaded in this theme, so data-scroll-direction and data-sticky-state are always
// undefined. Confirmed on the preview.
//
// No layout reads: window.scrollY does not force reflow, and the class is only written when the
// state actually changes.
(() => {
  const init = () => {
    const header = document.querySelector('header-component[sticky="always"]');
    if (!header) return;

    let scheduled = false;
    let scrolled = null;

    const update = () => {
      scheduled = false;

      const on = window.scrollY > 0 || !!document.querySelector('.search-modal-new[open]');
      if (on === scrolled) return;

      scrolled = on;
      header.classList.toggle('scrolled', on);
    };

    update();
    document.addEventListener(
      'scroll',
      () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
